import React from 'react'
import { countries } from './countries'
import axios from 'axios'
import debounce from 'lodash/debounce'


// returns uniques dmp and dmp name from the list of dmps and products
export const uniqueDmps = (array, allowAny = false, allowPleaseSelect = false) => {
    let hashMap = {}
    if (allowAny) {
        hashMap = { '': 'All' }
    }
    if (allowPleaseSelect) {
        hashMap = { '': 'Please select' }
    }

    array.map(it => {
        hashMap[it.dmp] = it.dmpName
    })
    return [
        ...Object.keys(hashMap).map(k => {
            return { dmp: k, dmpName: hashMap[k] }
        })
    ]
}


// 
// To fix the bug where sometimes localstorage is empty or invalid and users cannot see products, 
// bounce the resolutions (so if in a template we have mulitple resolution calls on those 2 functions we limit to 1 call to our API)
// then reload the localstorage with dmp and products labels from the API.

let debounced_loadDmpData = debounce(loadDmpData, 1000);

//
// This will call the API to refresh localStorage of dmp and products data.
// It will then re call the caller to rerun the function
//
function loadDmpData(fnCallback, args) {
    console.log("loadDmpData ")
    axios.get('/dmpDetails').then(response => {
        console.log('loadDmpData dmp details', response)
        window.localStorage.dmpsDetails = JSON.stringify(response.data.body || [])
        window.localStorage.dmps = JSON.stringify(uniqueDmps(response.data.body) || [])
        //recall the caller fn
        fnCallback(args)
    })
}

export const getDmp = dmp => {
    try {
        if(window.localStorage.dmps === undefined || window.localStorage.dmps === null || window.localStorage.dmps === "" || window.localStorage.dmps === "{}"){
            debounced_loadDmpData(getDmp, dmp)    
        }

        let dmps = JSON.parse(window.localStorage.dmps)
        if(dmps.length === 0){
            debounced_loadDmpData(getDmp, dmp)    
        }

        let obj = dmps.find(it => it.dmp === dmp)
        if (obj) return obj['dmpName']
        else return '-'
    } catch (e) {
        debounced_loadDmpData(getDmp, dmp)
    }
}
export const getDmpProduct = product => {
    try {
        if(window.localStorage.dmpsDetails === undefined || window.localStorage.dmpsDetails === null || window.localStorage.dmpsDetails === "" || window.localStorage.dmpsDetails === "{}"){
            debounced_loadDmpData(getDmpProduct, product)
        }

        let dmpsDetails = JSON.parse(window.localStorage.dmpsDetails)
        if(dmpsDetails.length === 0){
            debounced_loadDmpData(getDmpProduct, product)
        }

        let obj = dmpsDetails.find(it => it.product === product)
        if (obj) return obj['productName']
        else return '-'
    } catch (e) {
        debounced_loadDmpData(getDmpProduct, product)
    }
}
export const getRegion = region => {
    if (region == 'eu') return 'Europe'
    return 'United States'
}
export const parseDmpClientId = dmpClientId => {
    // check if this is an adform placeholder 
    if (!dmpClientId.startsWith("ADF_") ) return dmpClientId

    // else is an adform placeholder to parse 
    
    // check if this is an All country 
    if( dmpClientId === 'ADF_AC' ) {
        //return "All Countries";

        return <React.Fragment>
            <span style={{'font-size': '22px', 'top': '3px', 'position': 'relative'}}>{String.fromCodePoint(127758)}</span>&#160;&#160;All countries&#160;
        </React.Fragment>


    }
    
    let countryCode = dmpClientId
    countryCode = countryCode.replace("ADF_A_", ""); 
    countryCode = countryCode.substr(0, countryCode.indexOf("_"));
    console.log("countryCode ", countryCode)

    return <React.Fragment>
            <span style={{'font-size': '22px', 'top': '3px', 'position': 'relative'}}>{countryToFlag(countryCode)}</span>&#160;&#160;All agencies from {countryToName(countryCode)}&#160;
        </React.Fragment>
}


// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
export function countryToFlag(isoCode) {
    if(!isoCode || isoCode === undefined || isoCode === '') 
        return '';

    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode
}

function countryToName(code) {
    let item = countries.filter(el => el.iso2Code === code)
    if(item.length > 0){ 
        return item[0].name
    }
    return code
}


